import $ from 'jquery';
import _ from 'underscore';
import Numeral from 'numeral';
import Constants from 'root/constants';
import UI from 'root/ui';
import Sortable from 'sortablejs';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Router from 'root/router';
import View from 'root/view/base';
import View_Setup_Guide from 'view/setup_guide';
import Modals from 'root/modals';
import { getProjects as getInboxProjects } from 'service/inbox';
import { isProjectPage } from 'root/page/base';

var Menu = View.extend({
    inbox_unread_count: 0,

    views: {
        setup_guide: {}
    },

    events: {
        'click .switch-workspace'                : 'onSwitchWorkspace',
        'click .menu-toggle'                     : 'onToggleSideMenu',
        'click .project-selector'                : 'onToggleProjectDropdown',
        'click .workspace-name'                  : 'toggleProfilePanel',
        'click .sign-out'                        : 'logout',
        'click .account-upgrade'                 : 'accountUpgrade',
        'click .edit-profile'                    : 'editProfile',
        'click .edit-notification'               : 'editNotification',
        'click .app-feedback-bug'                : 'bugReport',
        'click .app-feedback-feature'            : 'featureRequest',
        'click .contact-us'                      : 'contactUs',
        'click .usage-upgrade'                   : 'accountUpgrade',
        'click .usage-dismiss'                   : 'dismissUsageWarning',
        'click .promo-upgrade'                   : 'accountUpgrade',
        'click .promo-dismiss'                   : 'dismissPromoOffer',
        'click .promo-claim'                     : 'claimPromoOffer',
        'click .help-center'                     : 'goToHelpCenter',
        'click .install-menu'                    : 'openCodeInstall',
        'click .install-code'                    : 'openCodeInstall',
        'click .confirm-email'                   : 'confirmEmail',
        'click .project-dropdown .project'       : 'onSelectProject',
        'input .project-dropdown-search input'   : 'onSearchProject',
        'click .feedback-upload'                 : 'onUploadFeedback',
        'click .project-settings'                : 'openProjectSettings',
        'click .edit-widget'                     : 'editWidget',
        'click .edit-survey'                     : 'editSurvey'
    },

    dom_handlers: {
        onToggleSideMenu: function(e) {
            var _close = () => {
                $(document.body).addClass('menu-small-closing');
                $('.overlay-menu').addClass('close');

                Util.transitionEnd(this.$el.find('.app-nav-side'), () => {
                    this.closeSmallMenu();
                });
            };

            if (UI.isMobile()) {
                var is_open = !$(document.body).hasClass('menu-small-open');

                if (is_open) {
                    $(document.body).addClass('menu-small-open');
                    var overlay = $('<div>').addClass('overlay overlay-menu').appendTo(document.body);

                    overlay.on('click', _close);
                } else {
                    _close();
                }
            } else {
                var is_closed = !$(document.body).hasClass('menu-large-closed');
                $(document.body).toggleClass('menu-large-closed', is_closed);

                if (is_closed) {
                    Cache.app.addUserSetting('menu_toggle_large', 'closed', false);
                } else {
                    Cache.app.deleteUserSetting('menu_toggle_large', false);
                }
            }
        },

        onSwitchWorkspace: function(e) {
            e.preventDefault();
            Modals.switchWorkspace();
        },

        onUploadFeedback: function(e) {
            if (Cache.account.isResponseLimitReached()) {
                Modals.unlockFeature('You\'ve reached 100% of your response limit for this period. You won\'t be able to add new feedback until the next billing cycle.', 'Adjust My Plan', 'Response limit exceeded', () => {
                    Cache.app.trackEvent('Billing Limit Modal');
                    Router.navigate('/account/billing', {trigger: true})
                });
                return;
            }

            var default_project_id = 0;
            var feedback_projects = Cache.project.where({is_archived: false, project_type: 'feedback'});

            if (feedback_projects.length === 1) {
                // there is only one project in the account. Always select it by default.
                default_project_id = feedback_projects[0].id;
            } else if (isProjectPage(this.page) && Cache.getDefaultProject().isFeedback()) {
                // inside a feedback project page. Select it by default.
                default_project_id = Cache.default_project_id;
            }

            Modals.newFeedback({
                project_id: default_project_id
            }, () => {
                Cache.app.dispatcher.trigger('Feedback::upload');
            });
        },

        onSearchProject: function(e) {
            var search = $(e.currentTarget).val().toLowerCase();
            var projects = Cache.project.where({is_archived: false});

            var visible_count = 0;
            projects.forEach((project) => {
                var name = project.get('name').toLowerCase();
                var key = project.get('project_key').toLowerCase();

                if (name.indexOf(search) !== -1 || key.indexOf(search) !== -1) {
                    visible_count++;
                    this.$el.find('.project-dropdown .project[data-val="' + project.id + '"]').show();
                } else {
                    this.$el.find('.project-dropdown .project[data-val="' + project.id + '"]').hide();
                }
            });

            this.$el.find('.project-dropdown').toggleClass('no-results', visible_count === 0);
        },

        onSelectProject: function(e) {
            var project_key = $(e.currentTarget).data('key');
            Router.navigate((project_key ? '/' + project_key : '') + '/dashboard/', {trigger: true});
        },

        openProjectSettings: function(e) {
            e.preventDefault();
            Modals.projectSettings(Cache.getDefaultProject());
        },

        editWidget: function(e) {
            e.preventDefault();
            Modals.openWidgetStudio();
        },

        editSurvey: function(e) {
            e.preventDefault();
            Modals.openSurveyStudio();
        },

        openCodeInstall: function(e) {
            if ($(e.currentTarget).data('val') === 'global') {
                Modals.getWidgetCode(true);
            } else {
                Modals.getWidgetCode(false);
            }
        },

        dismissUsageWarning: function(e) {
            var dropdown = this.$el.find('.usage-dropdown');
            var warning_code = dropdown.data('val');

            dropdown.hide();
            Cache.app.addUserSetting('usage_warning', warning_code, false);
        },

        dismissPromoOffer: function(e) {
            this.$el.find('.promo-offer').remove();
            Cache.add('promo_offer_dismiss', (new Date()).getTime(), true);
        },

        claimPromoOffer: function(e) {
            var is_widget_installed = Cache.account.get('onboarding').widget_install ? true : false;

            if (is_widget_installed) {
                // handled by intercom element click
            } else {
                Modals.verify50PromoOffer();
            }
        },

        bugReport: function(e) {
            this.openFeedbackWidget('bug');
        },

        featureRequest: function(e) {
            var session_info = btoa(JSON.stringify({
                email: Cache.getRealUser().get('email'),
                name : Cache.getRealUser().get('name')
            }));

            var portal_url = 'https://app.ideas.userback.io/p/KOfO1shsBi?sso_gl=' + encodeURIComponent(session_info);

            window.open(portal_url, 'ideas');
        },

        contactUs: function(e) {
            UI.openLiveChat();
        },

        goToHelpCenter: function(e) {
            window.open('https://support.userback.io/', 'help_center', 'noopener');
        },

        onToggleProjectDropdown: function(e) {
            if ($(e.target).hasClass('project-dropdown-search') || $(e.target).parents('.project-dropdown-search').length) {
                // ignore
                return;
            }

            this.$el.find('.project-dropdown').toggleClass('open');
        },

        toggleProfilePanel: function(e) {
            this.$el.find('.profile-dropdown').toggleClass('open');
        },

        confirmEmail: function(e) {
            Modals.sendEmailConfirmation('To activate your account');
        },

        editProfile: function(e) {
            e.preventDefault();
            Modals.editProfile();
        },

        editNotification: function(e) {
            e.preventDefault();
            Modals.editUserNotification(Cache.real_user_id);
        },

        logout: function(e) {
            e.preventDefault();

            if (Cache.app.is_admin_login) {
                Cache.app.request({
                    action: 'admin/loginAdmin',
                    success: function(response) {
                        window.location = Cache.app.host + '/admin/';
                    }
                });
            } else {
                var workspace_domain = false;
                if (!Cache.app.isGenericHost()) {
                    workspace_domain = window.location.hostname;
                }
                window.location = Cache.app.host + '/logout/' + (workspace_domain ? '?wd=' + workspace_domain : '');
            }
        },

        logback: function(e) {
            e.preventDefault();
        },

        accountUpgrade: function(e) {
            Modals.choosePlan();
        },

        onDocumentClick: function(e) {
            // project dropdown
            if (($(e.target).hasClass('project-selector') || $(e.target).parents('.project-selector').length) && !$(e.target).parents('.project-dropdown').length) {
                // ignore
            } else if ($(e.target).hasClass('project-dropdown-search') || $(e.target).parents('.project-dropdown-search').length) {
                // ignore
            } else {
                this.$el.find('.project-dropdown').removeClass('open');
            }

            // profile dropdown
            if ($(e.target).hasClass('workspace-name') || $(e.target).parent().hasClass('workspace-name')) {
                // ignore
            } else {
                this.$el.find('.profile-dropdown').removeClass('open');
            }
        }
    },

    event_handlers: {
        contactUs: function() {
            UI.openLiveChat();
        },

        onBuildPage: function(page) {
            this.page = page;

            this.$el.find('header').toggleClass('home', !isProjectPage(this.page));

            this.closeSmallMenu();
        },

        onUserSettingChange: function(model) {
            if (model.get('setting_name') === 'project_starred') {
                this.renderFavorites();
            }
        },

        onProjectChange: function() {
            this.renderFavorites();
            this.renderProjectMenu();
            this.renderPageLocation();
        },

        onInboxNotificationChange: function() {
            clearTimeout(this.inbox_change_timeout);

            // add a delay to prevent multiple requests when 10 notifications are changed at once
            this.inbox_change_timeout = setTimeout(() => {
                this.pollInboxNotifications();
            }, 100);
        }
    },

    closeSmallMenu: function() {
        $(document.body).removeClass('menu-small-open');
        $(document.body).removeClass('menu-small-closing');
        $('.overlay-menu').remove();
    },

    openFeedbackWidget: function(form) {
        var _open = function() {
            Userback.widget_settings = {
                name_field: true,
                rating_help_message: 'Get in touch with us'
            };

            if (form) {
                Userback.open(form);
            } else {
                Userback.open();
            }
        };

        if (typeof Userback === 'object' && Userback.open && Userback.isLoaded()) {
            _open();
        } else {
            var _interval = setInterval(() => {
                if (typeof Userback === 'object' && Userback.open && Userback.isLoaded()) {
                    clearInterval(_interval);
                    _open();
                }
            }, 200);
        }
    },

    // this function is called on every page build
    highlightMenu: function(page) {
        var mapping = {
            'feedback_details' : 'feedback'
        };

        var child_menu = {
            'account_settings': ['account', 'billing', 'referral', 'branding', 'connected_app', 'extension_key', 'api_token', 'integration_log']
        };

        page = mapping[page] || page;

        var parent_page = '';
        _.each(child_menu, function(pages, key) {
            pages.forEach(function(page_name) {
                if (page === page_name) {
                    parent_page = key;
                }
            });
        });

        this.$el.find('header nav > a').removeClass('active').filter('[data-name="' + (parent_page || page) + '"]').addClass('active');
        this.$el.find('.app-nav-side a.menu').removeClass('active').filter('[data-name="' + (parent_page || page) + '"]').addClass('active');

        // update breadcrumb on page build
        this.renderPageLocation(parent_page || page);
    },

    initialize: function() {
        this.listenTo(Cache.getRealUser(), 'change',     this.renderProfileMenu);
        this.listenTo(Cache.user_setting,  'add remove', this.event_handlers.onUserSettingChange.bind(this));

        Cache.app.dispatcher.on('contactUs', this.event_handlers.contactUs.bind(this));
        Cache.app.dispatcher.on('UI::build_page', this.event_handlers.onBuildPage.bind(this));

        var on_project_change = () => {
            this.renderProjectMenu();         // app menu
        };

        this.on('remove', () => {
            Cache.app.dispatcher.off('update:Cache:default_project_id', on_project_change);
        });

        Cache.app.dispatcher.on('update:Cache:default_project_id', on_project_change);

        this.listenTo(Cache.project, 'change:name',        this.event_handlers.onProjectChange);
        this.listenTo(Cache.project, 'change:is_archived', this.event_handlers.onProjectChange);
        this.listenTo(Cache.project, 'change:logo',        this.event_handlers.onProjectChange);
        this.listenTo(Cache.project, 'change:project_key', this.event_handlers.onProjectChange);
        this.listenTo(Cache.project, 'sort',               this.renderProjectDropdown);

        this.listenTo(Cache.workspace, 'change:display_name', this.renderWorkspaceName);
        this.listenTo(Cache.workspace, 'change:logo_url',     this.renderWorkspaceName);

        this.listenTo(Cache.inbox_notification, 'add',            this.event_handlers.onInboxNotificationChange);
        this.listenTo(Cache.inbox_notification, 'remove',         this.event_handlers.onInboxNotificationChange);
        this.listenTo(Cache.inbox_notification, 'change:is_read', this.event_handlers.onInboxNotificationChange);

        $(document).on('click.menu', this.dom_handlers.onDocumentClick.bind(this));
        this.on('remove', () => {
            $(document).off('click.menu');
        });

        // poll inbox notifications
        if (Cache.account.hasFeature('inbox')) {
            this.pollInboxNotifications();
        }

        this.views.setup_guide = new View_Setup_Guide();
    },

    pollInboxNotifications: function() {
        clearTimeout(this.inbox_poll_timeout);

        var projects_search = {...getInboxProjects()};
        Cache.app.getProjectsByUser(Cache.real_user_id).forEach((project) => {
            if (projects_search[project.id] === undefined) {
                projects_search[project.id] = 'on';
            }
        });

        Cache.app.request({
            action: 'inbox/search',
            data: {
                limit: 1,
                show_read: false,
                projects: projects_search
            },
            success: (response) => {
                this.inbox_unread_count = response.count;

                var total = '';

                if (this.inbox_unread_count > 99) {
                    total = '99+';
                } else if (this.inbox_unread_count > 0) {
                    total = this.inbox_unread_count;
                }

                this.$el.find('.inbox-new-counter').text(total);
                UI.toggleFaviconNotification(this.inbox_unread_count > 0);

                this.inbox_poll_timeout = setTimeout(() => {
                    this.pollInboxNotifications();
                }, 60000); // poll every 60 seconds
            }
        });
    },

    getGettingStartedStatus: function() {
        var status = Cache.app.getUserSetting('getting_started_page_status');

        if (status === null) {
            status = 'open';
        }

        return status;
    },

    // profile dropdown
    renderProfileMenu: function() {
        var real_user = Cache.getRealUser();

        if (!real_user) {
            return;
        }

        var content =

        '<div class="profile-dropdown dropdown-box">' +
            '<div>' +
                '<div class="account-menu">' +
                    (Cache.app.isAdmin() ?
                    '<div>' +
                        '<div class="subtitle">Workspace</div>' +
                        '<a class="navigation" href="/account/">' +
                            '<span class="icon"><i class="fa-regular fa-fw fa-cog"></i></span>Workspace Settings' +
                        '</a>' +

                        (Cache.account.displayUpgrade() ?
                        '<a class="account-upgrade text-shiny" href="#">' +
                            '<span class="icon"><i class="fa-regular fa-fw fa-balloon"></i></span>' +
                            'Upgrade' +
                        '</a>' :
                        '<a class="navigation" href="/account/billing">' +
                            '<span class="icon"><i class="fa-regular fa-fw fa-balloon"></i></span>' +
                            'Manage Subscription' +
                        '</a>') +
                    '</div>' : '') +

                    '<div>' +
                        '<div class="subtitle">' + real_user.escape('email') + '</div>' +
                        '<a href="#" class="edit-profile">' +
                            '<img class="user-16 icon" src="' + Util.htmlEntities(real_user.getAvatar(32)) + '">' +
                            'My Profile' +
                            (real_user.get('is_email_confirmed') ? '' : '<span class="alert tooltip" data-title="Your email address isn\'t confirmed"><i class="fas fa-exclamation-circle"></i></span>') +
                        '</a>' +
                        '<a href="#" class="edit-notification">' +
                            '<span class="icon"><i class="fa-regular fa-fw fa-bell"></i></span>' +
                            'Notifications' +
                        '</a>' +
                    '</div>' +
                    '<div>' +
                        (Cache.workspace.length > 1 ?
                        '<a href="#" class="switch-workspace">' +
                            '<span class="icon"><i class="fa-regular fa-fw fa-arrows-rotate"></i></span>' +
                            'Switch Workspace' +
                        '</a>' : '') +
                        '<a href="/login/" class="sign-out">' +
                            '<span class="icon"><i class="fa-regular fa-fw fa-sign-out"></i></span>' +
                             (Cache.app.is_admin_login ? 'Back to Admin' : 'Sign Out') +
                        '</a>' +
                    '</div>' +

                    (Cache.app.isSuperAdmin() ?
                    '<div>' +
                        '<a class="navigation" href="/admin/">' +
                            '<span class="icon"><i class="fa-solid fa-fw fa-dolphin"></i></span>' +
                            'Userback Admin' +
                        '</a>' +
                    '</div>' : '') +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.find('.menu-profile').html(content);
    },

    // main app menu
    renderProjectMenu: function() {
        if (!Cache.getDefaultProject()) {
            return;
        }

        var nav_content =
        '<nav>' +
            (Cache.getDefaultProject().isFeedback() ?

            // feedback
            '<a class="navigation" data-name="dashboard" href="/' + Cache.getDefaultProject().get('project_key') + '/dashboard/">Overview</a>' +
            '<a class="navigation" data-name="feedback" href="/' + Cache.getDefaultProject().get('project_key') + '/feedback/">Feedback</a>' +
            (Cache.account.get('appsumo') ?
            '<a class="navigation" data-name="feedback_design" href="/' + Cache.getDefaultProject().get('project_key') + '/feedback/design/">Designs</a>' : '') +
            '<a class="edit-widget" data-name="widget" href="#"">Widget</a>'

            :

            // survey
            '<a class="navigation" data-name="dashboard" href="/' + Cache.getDefaultProject().get('project_key') + '/dashboard/">Overview</a>' +
            (Cache.app.isClient() ? '' :
            '<a class="navigation" data-name="response" href="/' + Cache.getDefaultProject().get('project_key') + '/response/">Responses</a>') +
            '<a class="edit-survey" data-name="survey" href="#"">Survey</a>') +

            // All
            (Cache.app.isClient() ? '' :
            '<a class="navigation" data-name="integration" href="/' + Cache.getDefaultProject().get('project_key') + '/integration/">Connect</a>') +
        '</nav>';

        this.$el.find('.region-header-menu').html(nav_content);
    },

    renderPageLocation: function(page) {
        var content = '';
        var has_project_dropdown = false;

        this.$el.find('.project-shortcut').removeClass('active');

        switch (page) {
            case 'inbox':
                content =
                '<a href="/inbox/" class="navigation">' +
                    '<span class="menu-icon"><i class="fa-solid fa-inbox"></i></span>' +
                    '<span class="text">Inbox</span></a>' +
                '</a>';

                break;
            case 'project':
                content =
                '<a href="/project/" class="navigation">' +
                    '<span class="menu-icon"><i class="fa-solid fa-folder"></i></span>' +
                    '<span class="text">Projects</span></a>' +
                '</a>';

                break;
            case 'account_settings':
                content =
                '<a href="/account/" class="navigation">' +
                    '<span class="menu-icon"><i class="fa-solid fa-cog"></i></span>' +
                    '<span class="text">Workspace Settings</span></a>' +
                '</a>';

                break;
            case 'session_replay':
                content =
                '<a href="/session_replay/" class="navigation">' +
                    '<span class="menu-icon"><i class="fa-solid fa-circle-play"></i></span>' +
                    '<span class="text">Replays</span></a>' +
                '</a>';

                break;
            case 'user_segment':
                content =
                '<a href="/user_segment/" class="navigation">' +
                    '<span class="menu-icon"><i class="fa-solid fa-layer-group"></i></span>' +
                    '<span class="text">Segments</span></a>' +
                '</a>';

                break;
            case 'member':
                content =
                '<a href="/member/" class="navigation">' +
                    '<span class="menu-icon"><i class="fa-solid fa-user"></i></span>' +
                    '<span class="text">Members</span></a>' +
                '</a>';

                break;
            case 'admin':
                content +=
                '<a href="/admin/" class="navigation">' +
                    '<span class="menu-icon"><i class="fa-solid fa-folder"></i></span>' +
                    '<span class="text">Admin</span></a>' +
                '</a>';
                break;
            default:
                var project = Cache.getDefaultProject();

                if (project) {
                    content =
                    '<a href="/project/" class="navigation">' +
                        '<span class="menu-icon"><i class="fa-solid fa-folder"></i></span>' +
                        '<span class="text">Projects</span></a>' +
                    '</a>' +
                    '<span class="project-selector">' +
                        (project.get('logo') ?
                        '<span class="project-logo-icon-small" style="background-image:url(' + project.escape('logo') + ');"></span>' :
                        '<span class="project-type-icon-small" data-val="' + (project.isFeedback() ? 'feedback' : 'survey') +'"></span>') +
                        '<span class="text" data-title="' + project.escape('name') + '">' + project.escape('name') + '</span>' +
                        '<span class="text-icon margin-left-8"><i class="fa-solid fa-chevron-down"></i></span>' +
                        '<div class="project-dropdown"></div>' +
                    '</span>';

                    this.$el.find('.project-shortcut[data-val="' + project.id + '"]').addClass('active');

                    has_project_dropdown = true;
                }

                break;
        }

        this.$el.find('.page-location').html(content);

        if (has_project_dropdown) {
            this.renderProjectDropdown();

            // sort projects
            if (!Cache.statistics.get('project_count') && !Cache.statistics.is_loading) {
                Cache.statistics.syncProjectCount();
            }
        }
    },

    getUsageWarning: function() {
        var usage = Cache.account.getUsage();

        var response_total = usage.feedback + usage.survey_response;
        var session_total  = usage.session_recording;

        var response_limit = Cache.account.getResponseLimit();
        var session_limit  = Cache.account.getSessionLimit();

        // 50, 80, 100
        var usage_warning = {
            response: 0,
            session: 0
        };

        // response
        if (response_total / response_limit >= 1) {
            usage_warning.response = 100;
        } else if (response_total / response_limit >= 0.8) {
            usage_warning.response = 80;
        } else if (response_total / response_limit >= 0.5) {
            usage_warning.response = 50;
        }

        // session
        if (session_total / session_limit >= 1) {
            usage_warning.session = 100;
        } else if (session_total / session_limit >= 0.8) {
            usage_warning.session = 80;
        } else if (session_total / session_limit >= 0.5) {
            usage_warning.session = 50;

            // do not show 50% soft warning to old 2022 pricing accounts
            if (!Cache.account.isPricing2024()) {
                usage_warning.session = 0;
            }
        }

        return usage_warning;
    },

    getAccountUpgradeMenu: function() {
        var menu = '';

        if (Cache.getRealUser() && Cache.account.displayUpgrade()) {
            var days_remaining = Util.daysDiff(Cache.account.get('trial_expiry_date'));
            var trial_expiry_reminder = '';

            if (days_remaining < 0) {
                trial_expiry_reminder += 'Trial expires in ' + ((days_remaining * -1) + 1) + ' day' + (days_remaining === 1 ? '' : 's');
            } else {
                trial_expiry_reminder += 'Trial expires today';
            }

            menu =
            '<button type="button" class="shiny tiny account-upgrade tooltip" data-title="' + trial_expiry_reminder + '" data-position="down">' +
                '<span>' +  (Cache.account.get('referred_by') ? 'UPGRADE $1' : 'UPGRADE') + '</span>' +
            '</button>';
        }

        return menu;
    },

    getUsageWarningDropdown: function() {
        if (!Cache.account.isPricing2024() && !Cache.account.hasFeature('full_session_recording')) {
            return '';
        }

        var usage = Cache.account.getUsage();

        var response_total = usage.feedback + usage.survey_response;
        var session_total  = usage.session_recording;

        var usage_warning = this.getUsageWarning();

        var warning_code = usage_warning.response + ',' + usage_warning.session;
        var show_warning = usage_warning.response > 0   || usage_warning.session > 0;
        var seen_warning = Cache.app.getUserSetting('usage_warning', false) === warning_code;

        var response_percentage = Math.round(response_total / Cache.account.getResponseLimit() * 100);
        var session_percentage  = Math.round(session_total / Cache.account.getSessionLimit() * 100);

        var html = '';

        if (show_warning) {
            html +=
            '<div class="usage-dropdown" data-val="' + warning_code + '" style="display:' + (seen_warning ? 'none' : 'block') + ';">' +
                '<div class="grid-gap-12">' +
                    (usage_warning.response > 0 ?
                    '<div class="flex-start">' +
                        '<div class="donut-meteor">' +
                            '<svg width="100%" height="100%" viewBox="0 0 40 40">' +
                                '<linearGradient id="donutsegment" x1="0" y1="0" x2="1" y2="1">' +
                                    '<stop offset="0%" stop-color="var(--colour-feedback-600)"></stop>' +
                                    '<stop offset="100%" stop-color="var(--colour-survey-600)"></stop>' +
                                '</linearGradient>' +
                                '<circle cx="20" cy="20" r="16" fill="#fff"></circle>' +
                                '<circle class="donut-ring" cx="20" cy="20" r="16" fill="transparent" stroke-width="4"></circle>' +
                                '<circle class="donut-segment" cx="20" cy="20" r="16" fill="transparent" stroke="url(#donutsegment)" stroke-width="4" stroke-dasharray="' + response_percentage + ' ' + (100 - response_percentage) + '" stroke-dashoffset="25"></circle>' +
                            '</svg>' +
                            '<div class="percentage">' + response_percentage + '%</div>' +
                        '</div>' +
                        '<div>' +
                            '<div class="font-weight-semibold margin-bottom-4">Monthly responses</div>' +
                            '<div>' + Numeral(response_total).format('0,0') + ' of ' + Numeral(Cache.account.getResponseLimit()).format('0,0') + ' used</div>' +
                        '</div>' +
                    '</div>' : '') +

                    (usage_warning.session > 0 ?
                    '<div class="flex-start">' +
                        '<div class="donut-meteor">' +
                            '<svg width="100%" height="100%" viewBox="0 0 40 40">' +
                                '<linearGradient id="donutsegment" x1="0" y1="0" x2="1" y2="1">' +
                                    '<stop offset="0%" stop-color="var(--colour-feedback-600)"></stop>' +
                                    '<stop offset="100%" stop-color="var(--colour-survey-600)"></stop>' +
                                '</linearGradient>' +
                                '<circle cx="20" cy="20" r="16" fill="#fff"></circle>' +
                                '<circle class="donut-ring" cx="20" cy="20" r="16" fill="transparent" stroke-width="4"></circle>' +
                                '<circle class="donut-segment" cx="20" cy="20" r="16" fill="transparent" stroke="url(#donutsegment)" stroke-width="4" stroke-dasharray="' + session_percentage + ' ' + (100 - session_percentage) + '" stroke-dashoffset="25"></circle>' +
                            '</svg>' +
                            '<div class="percentage">' + session_percentage + '%</div>' +
                        '</div>' +
                        '<div>' +
                            '<div class="font-weight-semibold margin-bottom-4">Monthly session replays</div>' +
                            '<div>' + Numeral(session_total).format('0,0') + ' of ' + Numeral(Cache.account.getSessionLimit()).format('0,0') + ' used</div>' +
                        '</div>' +
                    '</div>' : '') +
                '</div>' +

                '<div class="margin-top-16">' +
                    (Cache.app.isAdmin() ?
                    '<button type="button" class="usage-upgrade small shiny full"><span>Upgrade for more</span></button>' : '') +
                    '<button type="button" class="usage-dismiss"><i class="fa-solid fa-xmark"></i></button>' +
                '</div>' +
            '</div>';
        }

        return html;
    },

    getOnboardingProgress: function() {
        var onboarding_items = Cache.account.getOnboardingProgress();

        var complete_count = 0;
        _.each(onboarding_items, (value) => {
            if (value) {
                complete_count++;
            }
        });

        if (Cache.account.hasFeature('survey') && Cache.app.isAdmin() && complete_count < _.size(onboarding_items)) {
            return complete_count + ' of ' + _.size(onboarding_items);
        } else {
            return '';
        }
    },

    // help dropdown
    getHelpMenu: function() {
        var html =
        '<ul class="dropdown">' +
            '<li class="help-center">Help Center</li>' +
            '<li class="separator"></li>' +
            '<li class="app-feedback-bug">Report a bug</li>' +
            '<li class="app-feedback-feature">Have an idea</li>' +
            '<li class="contact-us">Contact us</li>' +
        '</ul>';

        return html;
    },

    renderProjectDropdown: function() {
        this.$el.find('.project-dropdown').html(
            (Cache.statistics.get('project_count') ?
            (Cache.project.where({is_archived: false}).length > 9 ?
            '<div class="project-dropdown-search">' +
                '<input type="text" placeholder="Search projects...">' +
            '</div>' : '') +

            '<div>' +
                Cache.project.where({is_archived: false}).map((project) => {
                    return '' +
                    '<div class="project' + ((project.id === Cache.default_project_id ? ' active' : '')) + '" data-key="'+ project.get('project_key') +'" data-val="' + project.id + '">' +
                        (project.get('logo') ?
                        '<div class="project-logo-icon-small" style="background-image:url(' + project.escape('logo') + ');"></div>':
                        '<div class="project-type-icon-small" data-val="' + (project.isFeedback() ? 'feedback' : 'survey') +'"></div>') +
                        '<div class="project-name ellipsis">' + project.escape('name') + '</div>' +
                    '</div>';
                }).join('') +
            '</div>'

            :

            // loading state
            '<div class="loader-placeholder margin-12"></div>' +
            '<div class="loader-placeholder margin-12"></div>' +
            '<div class="loader-placeholder margin-12"></div>')
        );
    },

    renderWorkspaceName: function() {
        var workspace = Cache.getDefaultWorkspace();

        if (!workspace) {
            return;
        }

        this.$el.find('.workspace-name').html(
            (workspace.get('logo_url') ?
            '<div class="workspace-logo" style="background-image:url(' + workspace.escape('logo_url') + ')"></div>' :
            '<div class="workspace-logo workspace-logo-text">' + Util.htmlEntities(workspace.getName().slice(0, 1)) + '</div>') +
            '<span class="display-name">' + (Cache.getDefaultWorkspace().escape('display_name') || 'Userback') + '</span>'
        );
    },

    renderFavorites: function() {
        var starred_project_ids = Cache.app.getUserSetting('project_starred') ? Cache.app.getUserSetting('project_starred').split(',') : [];
        var favorite_project_order = Cache.app.getUserSetting('favorite_project_order', false);

        starred_project_ids = starred_project_ids.map((project_id) => {
            return parseInt(project_id, 10);
        });

        if (favorite_project_order) {
            favorite_project_order = favorite_project_order.split(',').map((project_id) => {
                return parseInt(project_id, 10);
            });
        } else {
            favorite_project_order = [];
        }

        starred_project_ids = starred_project_ids.filter((project_id) => {
            var project = Cache.project.get(project_id);
            return project && !project.get('is_archived');
        });


        starred_project_ids = starred_project_ids.sort((a, b) => {
            var pos_a = favorite_project_order.indexOf(a);
            var pos_b = favorite_project_order.indexOf(b);

            if (pos_a < pos_b) {
                return -1;
            } else if (pos_a > pos_b) {
                return 1;
            } else {
                return 0;
            }
        });

        var html = '<div class="heading">Favorites</div>';

        html += '<div class="region-favorited-projects">';

        if (starred_project_ids.length) {
            html +=
            starred_project_ids.map((project_id) => {
                var project = Cache.project.get(project_id);

                if (!project || project.get('is_archived')) {
                    return '';
                } else {
                    return '' +
                    '<a href="'+ (project.get('project_key') ? '/' + project.get('project_key') : '') +'/dashboard/" class="menu navigation project-shortcut" data-key="'+ project.get('project_key') +'" data-val="' + project_id + '">' +
                        (project.get('logo') ?
                        '<span class="project-logo-icon-small" style="background-image:url(' + project.escape('logo') + ');"></span>' :
                        '<span class="project-type-icon-small" data-val="' + (project.isFeedback() ? 'feedback' : 'survey') + '"></span>') +
                        '<span class="menu-text">' + project.escape('name') + '</span>' +
                        (project.isFeedback() ? '' : '') +
                    '</a>';
                }
            }).join('');
        } else {
            html += '<div class="empty">Click the stars on Projects to add your favorite projects here.</div>';
        }

        html += '</div>';

        this.$el.find('.region-favorites').html(html);

        if (starred_project_ids.length > 1) {
            new Sortable(this.$el.find('.region-favorited-projects').get(0), {
                ghostClass: 'drag-placeholder',
                animation: 200,
                onStart: () => {
                    this.$el.find('.project-shortcut').addClass('drag-start');
                },
                onEnd: () => {
                    this.$el.find('.project-shortcut').removeClass('drag-start');
                },
                onSort: () => {
                    var project_ids = [];
                    this.$el.find('.project-shortcut').each(function() {
                        project_ids.push($(this).data('val'));
                    });

                    Cache.app.addUserSetting('favorite_project_order', project_ids.join(','), false);
                }
            });
        }
    },

    render: function() {
        var real_user = Cache.getRealUser();
        var workspace_member = Cache.getRealWorkspaceMember();

        var content = '';

        if (real_user) {
            content +=
            '<div class="menu-profile"></div>' +
            '<div class="app-nav-side">' +
                '<div class="region-menu">' +
                    '<div class="flex-between margin-bottom-8">' +
                        '<div class="workspace-name"></div>' +
                        '<button type="button" class="menu-toggle"><i class="fa-solid fa-bars"></i></button>' +
                    '</div>' +

                    (Cache.account.hasFeature('inbox') ?
                    '<a class="menu navigation" href="/inbox/" data-name="inbox">' +
                        '<span class="menu-icon"><i class="fa-solid fa-fw fa-inbox"></i></span>' +
                        '<span class="menu-text">Inbox</span>' +
                        '<span class="menu-notify inbox-new-counter"></span>' +
                    '</a>' : '') +

                    '<a class="menu navigation" href="/project/" data-name="project">' +
                        '<span class="menu-icon"><i class="fa-solid fa-fw fa-folder"></i></span>' +
                        '<span class="menu-text">Projects</span>' +
                    '</a>' +
                    (Cache.app.isClient() ? '' :
                    (workspace_member.hasAccess(Constants.ACCESS_SESSION_REPLAY, 0) ?
                    '<a class="menu navigation" href="/session_replay/" data-name="session_replay">' +
                        '<span class="menu-icon"><i class="fa-solid fa-fw fa-circle-play"></i></span>' +
                        '<span class="menu-text">Replays</span>' +
                    '</a>' : '') +
                    (workspace_member.get('role') !== Constants.CLIENT ?
                    '<a class="menu navigation" href="/user_segment/" data-name="user_segment">' +
                        '<span class="menu-icon"><i class="fa-solid fa-fw fa-layer-group"></i></span>' +
                        '<span class="menu-text">Segments</span>' +
                    '</a>' : '') +
                    '<a class="menu navigation" href="/member/" data-name="member">' +
                        '<span class="menu-icon"><i class="fa-solid fa-fw fa-user"></i></span>' +
                        '<span class="menu-text">Members</span>' +
                    '</a>') +
                '</div>' +

                '<div class="region-favorites"></div>' +

                '<div class="region-account-offer">' +
                    '<div class="region-setup-guide"></div>' +
                    this.getUsageWarningDropdown() +
                '</div>' +
            '</div>' +
            '<header>' +
                '<div class="header-home">' +
                    '<div class="flex-start">' +
                        '<button class="menu-toggle" type="button"><i class="fa-solid fa-bars"></i></button>' +
                        '<div class="page-location"></div>' +
                    '</div>' +
                    '<div class="region-header-menu"></div>' +
                    '<div class="nav-settings">' +
                        this.getAccountUpgradeMenu() +

                        (Cache.app.isClient() ? '' :
                        '<div class="install-menu" data-val="global">' +
                            '<div class="menu-icon"><i class="fa-solid fa-square-code"></i></div>' +
                        '</div>') +

                        '<div class="help-menu button-dropdown">' +
                            '<button type="button" class="menu-icon"><i class="fa-regular fa-question-circle"></i></button>' +
                            '<div>' + this.getHelpMenu() + '</div>' +
                        '</div>' +

                        (Cache.app.isAdmin() ?
                        '<div class="settings-menu">' +
                            '<a class="project-settings menu-icon tooltip" data-title="Project Settings" data-position="down" data-offset="0,-24" href="#"><i class="fa-solid fa-cog"></i></a>' +
                        '</div>' : '') +

                        (Cache.app.isClient() ? '' :
                        '<div class="upload-menu">' +
                            '<button type="button" class="feedback-upload menu-icon tooltip" data-title="Add Feedback" data-position="down" data-offset="-20,-24"><i class="fa-solid fa-circle-plus"></i></button>') +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</header>';
        }

        this.$el.html(content);

        this.renderWorkspaceName();
        this.renderFavorites();
        this.renderProfileMenu();
        this.renderProjectMenu();

        this.views.setup_guide.render().$el.appendTo(this.$el.find('.region-setup-guide'));

        $(document.body).toggleClass('menu-large-closed', Cache.app.getUserSetting('menu_toggle_large', false) === 'closed');

        return this;
    }
});

export default Menu;